import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=33766645&"
import script from "./Pause.vue?vue&type=script&lang=js&"
export * from "./Pause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports